/// <reference types="./mode.d.mts" />
import { Ok, CustomType as $CustomType } from "../gleam.mjs";
import { read } from "./mode.ffi.mjs";

export class Production extends $CustomType {}

export class Staging extends $CustomType {}

export class Development extends $CustomType {}

export class Cypress extends $CustomType {}

export function mode() {
  let $ = read();
  if ($ instanceof Ok) {
    let $1 = $[0];
    if ($1 === "cypress") {
      return new Cypress();
    } else if ($1 === "development") {
      return new Development();
    } else if ($1 === "staging") {
      return new Staging();
    } else if ($1 === "production") {
      return new Production();
    } else {
      return new Production();
    }
  } else {
    return new Production();
  }
}

export function dev() {
  let $ = mode();
  if ($ instanceof Production) {
    return false;
  } else if ($ instanceof Staging) {
    return false;
  } else if ($ instanceof Development) {
    return true;
  } else {
    return true;
  }
}

export function cypress() {
  let $ = mode();
  if ($ instanceof Production) {
    return false;
  } else if ($ instanceof Staging) {
    return false;
  } else if ($ instanceof Development) {
    return false;
  } else {
    return true;
  }
}
